'use strict';

var env = require('../invoke/env.js');
var buildURI = require('../invoke/build-uri.js');

var messageQueue = [];
var messageQueueFetch = function() {
    var response = messageQueue.length ? JSON.stringify(messageQueue) : '';
    messageQueue = [];
    if (response) return response;
};
window.messageQueueFetch = messageQueueFetch;

var pushBack = function(protocol, name, params) {
    params = params || {};
    var uri = protocol + '//' + name + '?params=' + encodeURIComponent(JSON.stringify(params, buildURI.processParams));
    if (env.platform === 'android') {
        if (env.supportPrompt) {
            window.prompt(uri); // eslint-disable-line no-alert
        } else {
            try {
                window['MeituanHotelWebviewBridge']['sendBridgeMessage'](uri);
            } catch (e) {}
        }
    } else if (env.platform === 'ios') {
        messageQueue.push(uri);
    } else {
        // for debug
        alert(uri); // eslint-disable-line no-alert
    }
};

module.exports = pushBack;



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/legency-lvyou/push-back.js
// module id = 318
// module chunks = 4